export function areMarketingCookiesEnabled() {
  return (
    window.adobePrivacy &&
    window.adobePrivacy.activeCookieGroups().includes('C0004')
  );
}

/**
 * @name trackMarketingPreferencesChange
 * @param { object } segmentConfig - segment config
 * @param { boolean } marketingCookiesEnabled - whether marketing cookies are enabled or not
 * @description Sends segment tracking event when a user changes their marketing preferences if track function is set in the configs
 */
export function trackMarketingPreferencesChange(
  segmentConfig,
  marketingCookiesEnabled
) {
  const shouldTrack =
    segmentConfig.track &&
    marketingCookiesEnabled !== segmentConfig.previousMarketingCookiesEnabled;
  if (shouldTrack) {
    const name = areMarketingCookiesEnabled()
      ? 'marketing-enabled'
      : 'marketing-disabled';
    segmentConfig.track(name);
  }
}
